import axios from 'axios'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import envConfigs from '../configs/envConfigs'

export const getFlightEnquiryResponse = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.getFlightEnquiryUrl}`
	const response = await portalAuthHttpClient.post(url, data)
    return response.data
}
